<template>
    <button
        class="text-uppercase bg-brand p-3 rounded-lg text-xl cursor-pointer uppercase"
    >
        <slot />
    </button>
</template>
